import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LoginPageResponse } from '../../oauth/models/headless-cms/login-page-response';
import { LoginService } from './login.service';
import { map, share } from 'rxjs/operators';
import { LoginChallengeDataService } from './login-challenge-data.service';
import { DomainDataService } from './domain-data.service';

@Injectable()
export class LoginPageApiService {
    private _currentLoginChallenge: string;
    private _currentDomain: string;
    private _data: LoginPageResponse;
    private _observable: Observable<LoginPageResponse>;
    constructor(
        private loginService: LoginService,
        private _loginChallengeDataService: LoginChallengeDataService,
        private _domainDataService: DomainDataService
    ) { }
    public getLoginPage(): Observable<LoginPageResponse> {
        const loginCallenge = this._loginChallengeDataService.getLoginChallenge();
        const domain = this._domainDataService.getDomain();
        // if `login_challenge` or `domain` changes then make new api request
        if (loginCallenge !== this._currentLoginChallenge || domain !== this._currentDomain) {
            this._currentLoginChallenge = loginCallenge;
            this._currentDomain = domain;
            this._data = null;
            return  this._newApiRequest();
        }
        // if `data` is available just return it as `Observable`
        if (this._data) {
            return of(this._data);
        }
        // if `this.observable` is set then the request is in progress
        // return the `Observable` for the ongoing request
        if (this._observable) {
            return this._observable;
        }
    }
    private _newApiRequest(): Observable<LoginPageResponse> {
        this._observable = this.loginService.getLoginPageResponse(this._currentLoginChallenge, this._currentDomain)
            .pipe(map(response => {
                // when the cached data is available we don't need the `Observable` reference anymore
                this._observable = null;
                this._data = response;
                return this._data;
                // make it shared so more than one subscriber can get the result
            }), share());
        return this._observable;
    }
}
